import { motion } from "framer-motion";

export default function ScannerLine({ size }) {
  return (
    <motion.div
      style={{
        height: "8px",
        width: `${size + 40}px`,
        borderRadius: "100px",
        background: "var(--chakra-colors-primary)",
        position: "absolute",
        top: 0,
        zIndex: 2
      }}
      animate={{
        y: [4, size - 12]
      }}
      transition={{
        duration: 1.5,
        repeat: Infinity,
        repeatType: "reverse",
        ease: "easeInOut"
      }}
    />
  );
}
